export default "__VITE_ASSET__xF_rnRqs__"